module.exports = __webpack_public_path__ + "static/media/expired_coupon_2.5d4db2fc.svg";